import React, { useContext } from 'react';
import { IconButton, Input, Select } from 'uxp/components';
import { QueryBuilderContext } from '@query-builder/QueryBuilderContext';
import './FieldMapper.scss';
export const FieldMapper = ({ fields, source, onChange, disableRename }) => {
    const context = useContext(QueryBuilderContext);
    const $L = (key) => context.uxpContext.$L(key);
    const updateField = (index, field, value) => {
        const newFields = [...fields];
        newFields[index] = Object.assign(Object.assign({}, newFields[index]), { [field]: value });
        onChange(newFields);
    };
    const addField = () => {
        const newFields = [...fields, {
                field: '',
                newField: ''
            }];
        onChange(newFields);
    };
    const removeField = (index) => {
        const newFields = fields.filter((_, i) => i !== index);
        onChange(newFields);
    };
    return React.createElement("div", { className: "lucy-query-engine-source-mapper-e2714483" },
        (fields || []).map((c, i) => React.createElement("div", { key: i, className: "lucy-query-engine-source-mapper-condition-e2714483" },
            React.createElement("div", { className: "lucy-query-engine-source-mapper-condition-field-e2714483" },
                React.createElement(Select, { selected: c.field, onChange: s => updateField(i, 'field', s), options: ((source === null || source === void 0 ? void 0 : source.schema) || []).map(f => ({
                        label: f.name,
                        value: f.name
                    })) })),
            !disableRename ? React.createElement("div", { className: "lucy-query-engine-source-mapper-condition-field-e2714483" },
                React.createElement(Input, { value: c.newField, onChange: txt => updateField(i, 'newField', txt) })) : null,
            React.createElement("div", { className: "lucy-query-engine-source-mapper-delete-wrap-e2714483" },
                React.createElement(IconButton, { type: 'delete', onClick: () => removeField(i), variant: 'danger' })))),
        React.createElement("div", { className: "lucy-query-engine-source-mapper__add-btn-e2714483", onClick: addField }, $L('lqe.fm.add-field')));
};
